import React, { useEffect, useMemo, useState } from 'react'
import './NewsEventsLanding.scss'
import NewsTarget from './components/NewsTarget'
import NewsService from 'app_services/campus/news/newsService'
import { IPost } from 'app_types/campus/postTypes'
import { Link} from 'react-router-dom';
import { routingService } from 'app_services/routingService';
import EventsService from 'app_services/campus/events/eventsService'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import useWindowWidth from 'app_hooks/useWindowWidth'

enum CURRENT_SECTION {
  NEWS = 'news',
  EVENTS = 'events'
}

const SECTION_NAME = {
  [CURRENT_SECTION.NEWS]: 'noticias',
  [CURRENT_SECTION.EVENTS]: 'eventos'
}

const SECTION_URL = {
  [CURRENT_SECTION.NEWS]: '/noticias',
  [CURRENT_SECTION.EVENTS]: '/eventos'
}

const MOVIL_BREAKPOINT = 760

const NewsEventsLanding = () => {
  const [news, setNews] = useState<IPost[]>([])
  const [events, setEvents] = useState<IPost[]>([])
  const [currentSection, setCurrentSection] = useState<CURRENT_SECTION>(CURRENT_SECTION.NEWS)
  const newsService = useMemo(() => new NewsService(), [])
  const eventsService = useMemo(() => new EventsService(), [])
  const { windowWidth } = useWindowWidth()
  const isMovil = windowWidth && windowWidth <= MOVIL_BREAKPOINT

  const fetchNews = async () => {
    const response = await newsService.fetchNews({
      pageNumber: 1,
      nPerPage: 10,
      isActive: true,
      postType: ['news'],
      postDate: {
        date: 'today',
        direction: 'lte'
      },
      locations: ['guest'],
      sort: {
        field: 'postDate',
        direction: -1
      }
    })
    if (response && response.posts) {
      setNews(response.posts)
    }
  }

  const fetchEvents = async () => {
    const allEvents: IPost[] = []
    const eventsResponse = await eventsService.fetchEvents({
      pageNumber: 1,
      nPerPage: 10,
      isActive: true,
      postType: ['events'],
      eventDate: {
        date: 'today',
        direction: 'gte'
      },
      locations: ['guest'],
      sort: {
        field: 'eventDate',
        direction: 1
      }
    })
    const onlineEvents = await eventsService.fetchEvents({
      pageNumber: 1,
      nPerPage: 10,
      isActive: true,
      postType: ['events'],
      startDate: {
        date: 'today',
        direction: 'lte'
      },
      endDate: {
        date: 'today',
        direction: 'gte'
      },
      locations: ['guest', 'live'],
      locationsGrouped: true,
      sort: {
        field: 'eventDate',
        direction: 1
      }
    })

    if (onlineEvents && onlineEvents.posts) {
      allEvents.push(...onlineEvents.posts)
    }

    if (eventsResponse && eventsResponse.posts) {
      allEvents.push(...eventsResponse.posts)
    }

    setEvents([...allEvents])
  }

  useEffect(()=>{
    fetchNews()
    fetchEvents()
  }, [])

  const getCardUrl = (id: string) => {
    if (currentSection === CURRENT_SECTION.NEWS) {
      return `/noticia/${id}`
    } else {
      return `/evento/${id}`
    }
  }

  const itemsToRender = currentSection === CURRENT_SECTION.NEWS ? news : events

  return (
    <div className='news-events-landing--container'>
      <div className='news-events-landing--container-buttons'>
        <button
          className={`news-events-landing--button ${currentSection === CURRENT_SECTION.NEWS ? 'active' : ''}`}
          onClick={() => setCurrentSection(CURRENT_SECTION.NEWS)}
        >
          Noticias
        </button>
        <button
          className={`news-events-landing--button ${currentSection === CURRENT_SECTION.EVENTS ? 'active' : ''}`}
          onClick={() => setCurrentSection(CURRENT_SECTION.EVENTS)}
        >
          Eventos
        </button>
      </div>
      <div className='news-events-landing--container-targets'>
        {itemsToRender.map((post) => (
          <Link to={routingService.getPublicPath(getCardUrl(post?.slug ? post.slug : post._id))}>
            <NewsTarget
              image={post.coverUrl}
              date={post.postDate}
              title={post.title}
              key={post._id}
              topic={post?.tags?.[0]?.name}
            />
          </Link>
        ))}
      </div>
      {!itemsToRender?.length && (
        <div className='news-events-landing--empty-container'>
          <TextComponent>Por el momento no hay {SECTION_NAME[currentSection]} disponibles</TextComponent>
        </div>
      )}
      <Link to={routingService.getPublicPath(SECTION_URL[currentSection])}>
        <div className='news-events-landing--see-everything'>
          {currentSection === CURRENT_SECTION.NEWS ? 'Ver todas las noticias' : 'Ver todos los eventos'}
        </div>
      </Link>

    </div>
  )
}

export default NewsEventsLanding
